.root {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  background: var(--color-brand-primary-soft);
  border: 1px solid rgba(11, 37, 69, 0.12);
  cursor: default;
}

.icon {
  font-size: 18px;
  color: var(--color-brand-primary);
  flex-shrink: 0;
}

.copy {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.eyebrow {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-tertiary);
}

.label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-brand-primary);
}
